/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as vehiclesSlice from './vehiclesSlice';

export default function* watchVehiclesSaga() {
 yield takeLatest(vehiclesSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(vehiclesSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(vehiclesSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(vehiclesSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(vehiclesSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  vehiclesSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  vehiclesSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  vehiclesSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  vehiclesSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  vehiclesSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
